import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Column, TotalItem, Summary, GroupItem, SortByGroupSummaryInfo } from "devextreme-react/data-grid";
import DateBox from 'devextreme-react/date-box';
import { PaginaListado } from "../../../Componentes/Compuestos/Paginas/PaginaListado";
import { LVGridCabeceraReporte } from "../../../Componentes/Basicos/LVGridCabeceraReporte";

export const COM_Reporte_DocsCompra_PercepcionesPercibidas = () => {
  const [data, setData] = useState([])
  const { COM_DocsCompra_Cabecera: { function_COM_DocsCompra_Cabecera_ListarPercepcionesPercibidas } } = require('neftis7_apicaller');

  const handleDataLoaded = (data) => {
    setData(data);
  };

  return (
    <PaginaListado
      Titulo="PERCEPCIONES PERCIBIDAS"
      funcion={function_COM_DocsCompra_Cabecera_ListarPercepcionesPercibidas}
      onDataLoaded={handleDataLoaded}
    >
      <div className="table-responsive">
        {data.length > 0 ? (
          <LVGridCabeceraReporte
            dataSource={data}
            id="gridContainer"
          >
            <Summary>
              <TotalItem
                column="IdDocCompra"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`} />
              <TotalItem
                column="ImporteImpuesto"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />

              <GroupItem
                column="IdDocCompra"
                summaryType="count"

                displayFormat="Registros: {0} "
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteImpuesto"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
            </Summary>

            <Column caption="Fecha" dataField="FEFecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
            <Column caption="Código" dataField="IdDocCompra" width="120" alignment="Right" dataType="number" />

            <Column caption="Proveedor" alignment="Center" >
              <Column caption="Código" dataField="IdProveedor" width="70" alignment="Right" dataType="number" />
              <Column caption="Descripción" dataField="RazonSocial" width="200" alignment="Left" dataType="string" />
              <Column caption="C.U.I.T." dataField="CUIT" width="120" alignment="Left" dataType="string" />
            </Column>

            <Column caption="Impuesto" dataField="ABM_IMP_ImpuestosTipos_Descripcion" width="200" alignment="Left" dataType="string" groupIndex={0} />
            <Column caption="Comprobante" dataField="Comprobante" width="200" alignment="Left" dataType="string" />

            <Column caption="Importes" alignment="Center">
              <Column caption="Neto" dataField="ImporteNeto" width="150" alignment="Right" dataType="number" format="currency" />
              <Column caption="Percepcion" dataField="ImporteImpuesto" width="150" alignment="Right" dataType="number" format="currency" />
              <Column caption="Porcentaje" dataField="Porcentaje" width="150" alignment="Right" dataType="number" />
            </Column>

          </LVGridCabeceraReporte>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListado>
  );
};
